module.exports = __webpack_public_path__ + "img/zincsearch.41b30716.svg";